<template>
  <stacked-card>
    <notification-card compact icon="atom" :icon-class="`has-text-${variant} fa-x5`">
      <template #title>
        <span :title="`Policy-set for ${deviceType} devices.`">
          <font-awesome-icon :icon="icon" :class="`${iconClass} mr-2`" />
          {{ cleanName }}
        </span>
      </template>
    </notification-card>
    <template #buttons>
      <b-button class="stacked-button" @click="view" :type="`is-${variant}`">
        <font-awesome-icon icon="sliders"/>
      </b-button>
      <b-button class="stacked-button is-dark" @click="search">
        <font-awesome-icon icon="search"/>
      </b-button>
    </template>
  </stacked-card>
</template>

<script>
import { mobilePolicyPrefix } from '@/services/consts'
import { mobileIcon, mobileVariant, desktopIcon, desktopVariant } from '@/services/devices'
export default {
  props: {
    name: String
  },
  computed: {
    cleanName () { return this.name.replace(mobilePolicyPrefix, '') },
    isMobile () { return this.name.indexOf(mobilePolicyPrefix) === 0 },
    icon () { return this.isMobile ? mobileIcon : desktopIcon },
    variant () { return this.isMobile ? mobileVariant : desktopVariant },
    deviceType () { return this.isMobile ? 'mobile' : 'desktop' },
    iconClass () { return `has-text-${this.variant}` },
  },
  methods: {
    search () {
      this.$store.commit('filters/resetWith', { policySet: this.name })
      this.$router.push({ name: 'search' })
    },
    view () {
      this.$router.push({ name: 'policy', params: { name: this.name } })
    }
  }
}
</script>